import * as Yup from 'yup';

export const terms = Yup.bool()
  .test(
    'acceptTerms',
    'You should to accept our Terms and Conditions for use service',
    value => value === true,
  )
  .required('You should to accept our Terms and Conditions for use service');
